import api from './axios';

export const fetchBookings = (params) =>
  api.get('/bookings', { params }).then(r => r.data);

export const fetchBooking = (id) =>
  api.get(`/bookings/${id}`).then(r => r.data.data);

export const createBooking = (payload) =>
  api.post('/bookings', payload).then(r => r.data.data);

export const patchBookingStatus = (id, status) =>
  api.patch(`/bookings/${id}/status`, { status }).then(r => r.data.data);

export const rescheduleBooking = (id, payload) =>
  api.put(`/bookings/${id}`, payload).then(r => r.data.data);

export const fetchClients = (params) =>
  api.get('/clients', { params }).then(r => r.data);

export const fetchClient = (id) =>
  api.get(`/clients/${id}`).then(r => r.data.data);

export const fetchClientBookings = (id) =>
  api.get(`/clients/${id}/bookings`).then(r => r.data.data);

export const createClient = (payload) =>
  api.post('/clients', payload).then(r => r.data.data);

export const updateClient = (id, payload) =>
  api.put(`/clients/${id}`, payload).then(r => r.data.data);

export const deleteClient = (id) =>
  api.delete(`/clients/${id}`).then(r => r.data);

export const fetchServices = () =>
  api.get('/services').then(r => r.data.data);

export const fetchStaff = () =>
  api.get('/staff').then(r => r.data.data);
